import {TextEditorServices} from '@frontapp/editor-html';
import React, {useRef, useState} from 'react';

import {DraftMessageModel} from '../../../../../../libs/shared/core/src/models/api/messageModel';
import {useInteractiveListOnCancel} from '../../../../../../libs/shared/ui/src/components/dropdowns/quickInsert/quickInsertCommon';
import {Anchor} from '../../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {AnswerModel} from '../../../../../models/api/answerModel';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {VariableInterpolator} from '../../../../../services/variableInterpolation/variableInterpolator';
import {AnswerDialogContainer} from '../../../../inboxes/composer/answers/answerDialogContainer';
import {AnswersDropdownContainer} from '../../../../inboxes/composer/answers/answersDropdownContainer';

/*
 * Props.
 */

interface QuickInsertAnswersDropdownProps {
  namespace: string;
  conversation: ConversationModel | null;
  channelId: number;
  message: DraftMessageModel;
  editorServices: TextEditorServices;
  interpolator: VariableInterpolator;
  anchor: Anchor;
  onSelect: (model: AnswerModel) => void;
  onCancel: () => void;
  onBack: () => void;
}

/*
 * Component.
 */

export const QuickInsertAnswersDropdown = (props: QuickInsertAnswersDropdownProps) => {
  const [onRequestClose, onAnswerSelect] = useInteractiveListOnCancel(props.onCancel, props.onSelect);

  const isCreatingOpenRef = useRef(false);
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const onCreateClick = () => {
    isCreatingOpenRef.current = true;
    setIsCreateOpen(true);
  };

  const onCreateRequestClose = () => {
    isCreatingOpenRef.current = false;
    setIsCreateOpen(false);
  };

  const onDropdownRequestClose = () => {
    if (isCreatingOpenRef.current) {
      // Keep the answers popover open if the create dialog is being opened.
      return;
    }
    onRequestClose();
  };

  return (
    <>
      <AnswersDropdownContainer
        isQuickInsert
        conversation={props.conversation}
        channelId={props.channelId}
        message={props.message}
        editorServices={props.editorServices}
        interpolator={props.interpolator}
        anchor={props.anchor}
        onCreateClick={onCreateClick}
        onAnswerSelect={onAnswerSelect}
        onRequestClose={onDropdownRequestClose}
        onBackButtonClick={props.onBack}
      />
      {isCreateOpen && (
        <AnswerDialogContainer
          isFromDraft={false}
          namespace={props.namespace}
          message={props.message}
          onRequestClose={onCreateRequestClose}
        />
      )}
    </>
  );
};
